module.exports = __webpack_public_path__ + "static/doctor-04-ba8bef83c850b959833fb32d8839b96d.png";